
import {
  computed,
  defineComponent,
} from 'vue';
import Chip from 'primevue/chip';
import {
  hasAccessToFeatures,
} from '@/composables/User';
import Tooltip from 'primevue/tooltip';

export default defineComponent({
  name: 'WidgetsPanelButton',
  components: {
    Chip,
  },

  directives: {
    tooltip: Tooltip,
  },

  props: {
    button: {
      type: Object,
      required: true,
    },

    translation: {
      type: Function,
      required: true,
    },

    iconColor: {
      type: String,
      required: false,
      default: '',
    },
  },

  setup(props) {
    const featurePermission = computed(() => hasAccessToFeatures(props.button.type));

    const isDisabled = computed(() => {
      if (props.button.disabled && typeof props.button.disabled === 'function') {
        return props.button.disabled();
      }
      return false;
    });

    return {
      featurePermission,
      isDisabled,
    };
  },
});
